<style lang="scss" scoped>
@use '~@/styles/base/variables';

div {
  /*border: 1px solid pink;*/
}

td {
  /*border: 1px solid greenyellow;*/
}

.toggle-button {
  right: 10px;
}

.exch-name {
  color: var(--color-neutral);
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  padding-left: 0px;
}

.exch-value {
  font-size: 14px;
  color: var(--color-text-light);
  text-align: center;
  padding-right: 0px;
}

.exch-img {
  height: 20px;
  padding: 2px;
  filter: brightness(10%);
}

.active {
  .exch-name {
    color: #b4b4b4;
  }

  .exch-value {
    color: #e6e6e6;
  }

  &.pause {
    background-image: linear-gradient(
      to bottom left,
      #ffd57b,
      #a67d28
    ) !important;

    .exch-name {
      color: var(--color-background);
    }

    .exch-value {
      color: var(--color-card);
    }
  }
  &.free {
    background-image: linear-gradient(
      to bottom left,
      #64a6c6,
      #216180
    ) !important;
  }
}

.qpair {
  font-size: 14px;
  width: 50%;
}

.qrate {
  font-size: 18px;
  font-weight: bold;
  color: var(--color-text-light);
  width: 50%;
  padding-right: 10px;
}

.exlabel {
  font-size: 16px;
}

.settingsbtn {
  position: absolute;
  top: 4px;
  right: -1px;
  color: var(--color-card);
}

.scrolling-wrapper {
  /*overflow-x: auto;*/
  /*overflow-y: hidden;*/
  /*white-space: nowrap;*/
  overflow-y: auto;
  /*direction: rtl;*/
}

.card {
  display: inline-block;
  /*direction:ltr;*/
  /*border-bottom: 1px dotted black;*/
}

.add-exch {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100px; height: 70px; padding-left: 20px ;
}

.scrolling-wrapper2 {
  /*width: 100px;*/
  /*height: 300px;*/
  overflow-y: auto;
  overflow-x: hidden;

  /*transform: rotate(-90deg);*/
  transform-origin: right top;
  transform: rotate(-90deg) translateY(-100px);
}

.card2 {
  transform: rotate(90deg);
  transform-origin: right top;
}

img {
  /*border: 1px solid #eee;*/
}

table {
  border-collapse: collapse;
}

.firstCell {
  border-bottom-left-radius: 5px;
  border-top-left-radius: 5px;
  /*border: 1px solid #eee;*/
}

.symbol-clickable {
  cursor: pointer;
}

.apiKeyMsg {
  border: 1px solid var(--color-neutral);
  border-radius: 5px;
  height: 40px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chooserdesktop {
  display: none;
}

.choosermobile {
  display: block;
}

.constructor-switch {
  padding-right: 20px;
  width: 80px;
  font-size: 12px;

  ::v-deep .ivu-switch-checked {
    background-image: linear-gradient(
      to bottom left,
      var(--color-success),
      var(--color-success-dark)
    );
  }
}

.disabled {
  opacity: 0.3;
  // filter: brightness(0.8);
  // cursor: not-allowed;
  pointer-events: none;
  user-select: none;
}

@media screen and (max-width: variables.$medium - 1px) {
  .constructor-switch {
    display: none;
  }
}

@media all and (min-width: 1000px) {
  .chooserdesktop {
    display: inline-block;
  }
  .choosermobile {
    display: none;
  }
}
</style>

<template>
  <div>
    <div style="position: relative;">
      <div
        id="header-wrapper"
        class="box headbox"
        style="height: 70px; overflow: visible"
      >
        <table width="100%">
          <tr>
            <td>
              <div style="height: 70px">
                <table>
                  <tr>
                    <td>
                      <div
                        class="scrolling-wrapper chooserdesktop"
                        style="border: 0px solidvar(--color-danger-light); height: 70px"
                        @wheel="onExchangesScroll"
                      >
                        <div
                          :class="{
                          active: exch.Id === currentExchangeId &&
                          (!$store.state.assets.allexchs || $route.name !== 'portfolio'),
                          firstCell: index === 0,
                          free: isExchangeFree,
                          pause: isExchangePaused,
                          disabled: isExchangeDisabled(exch.ExchId)
                        }"
                          :title="getExchangeTitle(exch)"
                          :key="exch.Id"
                          @click="selectExch(index)"
                          class="exchbtn card exchange-card"
                          v-for="(exch, index) in exchanges"
                        >
                          <Icon
                            @click="showEditModal(index)"
                            class="settingsbtn"
                            type="md-more"
                            v-if="exch.Id === currentExchangeId"
                          />
                          <div class="exch-name">
                            {{ exch.Name }}
                          </div>
                          <div style="height: 22px">
                            <img
                              class="exch-img"
                              :src="getExUrl(exch.ExchId)"
                            />
                          </div>
                          <!--                  <div v-else style='font-size: 14px;'>{{ constants.exchangeIds[exch.ExchId] }}</div>-->
                          <div
                            class="exch-value"
                            :class="{
                                yell: exch.ExchId === 'BIM',
                                'blur-balance': $store.state.sys.hideBalances,
                              }"
                            @click="changeUSDBTCValue(exch.Id)"
                          >
                            <div>{{ exchValue(exch.Id) }}</div>
                          </div>
                        </div>
                      </div>
                      <ExchChooser class="choosermobile" />
                    </td>
                    <td>
                      <div class="add-exch">
                        <Button
                          @click="showAddModal"
                          size="large"
                          :title="$text.tr('добавить биржу')"
                          type="dashed"
                        >+
                        </Button>
                      </div>
                    </td>
                    <td
                      v-if="!exchanges || exchanges.length == 0"
                      style="padding: 8px 0px"
                    >
                      <img
                        src="../../../assets/finger.svg"
                        width="50px"
                        height="50px"
                      />
                    </td>
                    <!--                  <td  v-if="!exchanges" style="padding: 23px 3px; font-size: 16px;">-->
                    <!--                    Для начала работы добавьте биржу-->
                    <!--                  </td>-->
                  </tr>
                </table>
              </div>
            </td>
            <td
              style="padding-right: 20px; width: 80px; font-size: 12px"
              v-if="currentExchange.ExchId === 'BIM'"
            >
              <Risk />
            </td>
            <td v-if="$route.name !== 'grids'" style="padding-right: 20px; width: 80px; font-size: 12px">
              <div style="text-align: center">
                <div style="margin-bottom: 5px">{{ $text.tr('ДЕМО') }}</div>
                <i-switch
                  :value="demoEnabled"
                  :disabled="
                    !this.$store.state.trade.tvEnabled &&
                    this.$store.state.trade.tvLoading
                  "
                  @on-change="demoChanged"
                ></i-switch>
              </div>
            </td>
            <td
              v-if="showConstructorSwitch"
              class="constructor-switch"
            >
              <div style="text-align: center">
                <div style="margin-bottom: 5px">
                  {{ $text.tr('КОНСТРУКТОР') }}
                </div>
                <i-switch v-model="isDashboardResponsive">
                  <Icon
                    type="ios-build-outline"
                    slot="close"
                  />
                </i-switch>
              </div>
            </td>
            <!-- <td
              v-else-if="$route.name !== 'bots'"
              style="padding-right: 10px; width: 40px; font-size: 12px"
            >
              <div style="text-align: center">
                <div style="margin-bottom: 5px">{{ $text.tr('ГРАФИК') }}</div>
                <i-switch v-model="$store.state.trade.showTV"></i-switch>
              </div>
            </td> -->
            <td style="width: 60px; text-align: right">
              <Dropdown />
            </td>
            <td style="text-align: right; padding-top: 0px; width: 150px">
              <table width="100%">
                <tr
                  :class="{ 'symbol-clickable': $route.name === 'terminal' || $route.name === 'bots' || $route.name === 'grids' }"
                  @click="selectSymbol('BTC_USDT')"
                >
                  <td class="qpair">BTC/USD</td>
                  <td class="qrate">
                    <Tooltip
                      :delay="600"
                      placement="left"
                      :content="$text.tr('Курс Binance')"
                    >
                      ${{ $store.state.sys.rates.btc }}
                    </Tooltip>
                  </td>
                </tr>
                <tr
                  :class="{ 'symbol-clickable': $route.name === 'terminal' || $route.name === 'bots' || $route.name === 'grids' }"
                  @click="selectSymbol('ETH_USDT')"
                >
                  <td class="qpair">ETH/USD</td>
                  <td class="qrate">
                    <Tooltip
                      :delay="600"
                      placement="left"
                      :content="$text.tr('Курс Binance')"
                    >
                      ${{ $store.state.sys.rates.eth }}
                    </Tooltip>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </div>
      <ToggleButton
        v-model="isHeaderCollapsed"
        targetId="header-wrapper"
        :shortcutName="!isMenuCollapsed && isHeaderCollapsed ? '' : 'Q'"
        :parentObject="{id: 'main', styleProp: 'paddingTop'}"
        class="toggle-button"
        direction="top"
      />
    </div>
    <div
      v-if="currentExchange.Status === 'PAU'"
      class="apiKeyMsg"
    >
      <span style="font-size: 17px">{{
        $text.tr(
          'API ключ биржи недействителен. Для продолжения работы замените ключ на новый.'
        )
      }}</span>
      <a
        :href="$text.tr('https://doc.capico.app/v/ru/ex/api/new-api')"
        target="_blank"
      >
        <span style="font-size: 14px; padding: 5px; color: var(--color-accent-dark)">{{
          $text.tr('Инструкция')
        }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import constants from '@/util/constants'
import Dropdown from '@/components/common/Header/Dropdown'
import Risk from '@/components/common/Header/Risk'
import ExchChooser from '@/components/common/Header/ExchChooser'
import terminal from '@/services/terminal'
import Bots from '@/services/bots'
import Grids from '@/services/grids'
import ToggleButton from '@/components/common/ToggleButton'
import { saveTradeExchange } from '@/store/index'

export default {
  components: { Dropdown, Risk, ExchChooser, ToggleButton },
  name: 'Header',
  props: {
    dashboard: Array,
    showConstructorSwitch: Boolean
  },
  data () {
    return {
      exindex: -1,
      updateRatesInterval: null
    }
  },
  watch: {
    '$route.meta.showDemoBackground': function () {
      this.toggleDemoBackground()
    },
    demoEnabled () {
      this.toggleDemoBackground()
    }
  },
  computed: {
    exchanges () {
      return this.$store.state.sys.exchanges
    },
    currentExchange: {
      get () {
        return this.$store.state.sys.tradeExchange
      },
      set (value) {
        this.$store.state.sys.tradeExchange = value
        saveTradeExchange(value, this.$store.state.sys.demo)
        this.$store.state.trade.editTradeId = null
        this.$store.state.trade.editTrade = null
        this.$store.state.assets.allexchs = false
      }
    },
    currentExchangeId () {
      return this.currentExchange.Id
    },
    currentExchangeIndex () {
      const currentExchangeIndex = this.exchanges.findIndex(item => {
        return item.Id === this.currentExchangeId
      })

      return currentExchangeIndex !== -1 ? currentExchangeIndex : 0
    },
    isExchangePaused () {
      return this.currentExchange.Status === 'PAU'
    },
    isExchangeFree () {
      return this.currentExchange.Free === true
    },
    demoEnabled () {
      return this.$store.getters.demoState
    },
    constants () {
      return constants
    },
    isDashboardResponsive: {
      get () {
        return this.$store.state.sys.isDashboardResponsive
      },
      set (value) {
        this.$store.state.sys.isDashboardResponsive = value
      }
    },
    isHeaderCollapsed: {
      get () {
        return this.$store.state.sys.isHeaderCollapsed
      },
      set (value) {
        this.$store.state.sys.isHeaderCollapsed = value
        localStorage.setItem('isHeaderCollapsed', value)
      }
    },
    isMenuCollapsed () {
      return this.$store.state.sys.isMenuCollapsed
    }
  },
  created () {
    this.toggleDemoBackground()
  },
  mounted () {
    this.$bus.$on('switch-to-previous-exchange', this.switchToPreviousExchange)
    this.$bus.$on('switch-to-next-exchange', this.switchToNextExchange)
  },
  methods: {
    isExchangeDisabled (eid) {
      // console.log(JSON.stringify(exch))
      if (this.$route.name === 'grids') {
        return eid !== 'BYF'
      } else {
        return false
      }
    },
    onExchangesScroll (e) {
      const offset = e.currentTarget.clientHeight
      let top = e.currentTarget.scrollTop

      if (e.currentTarget.scrollHeight === offset || top % offset !== 0) {
        return
      }

      if (e.deltaY > 0) {
        top += offset
      } else {
        top -= offset
      }

      e.preventDefault()
      e.currentTarget.scroll({
        top,
        behavior: 'smooth'
      })
    },
    switchToPreviousExchange () {
      if (!this.exchanges.length) {
        return
      }

      const previousExchangeIndex = this.currentExchangeIndex - 1
      if (previousExchangeIndex >= 0) {
        this.currentExchange = this.exchanges[previousExchangeIndex]
      } else {
        this.currentExchange = this.exchanges.slice(-1)[0]
      }
    },
    switchToNextExchange () {
      if (!this.exchanges.length) {
        return
      }

      const nextExchangeIndex = this.currentExchangeIndex + 1
      if (nextExchangeIndex <= this.exchanges.length - 1) {
        this.currentExchange = this.exchanges[nextExchangeIndex]
      } else {
        this.currentExchange = this.exchanges[0]
      }
    },
    getExchangeTitle (exch) {
      if (exch.Free === true) {
        return this.$text.tr('Подключено бесплатно')
      }

      if (exch.Status === 'PAU') {
        return this.$text.tr('Биржа на паузе')
      }

      return ''
    },
    selectSymbol (symbol) {
      if (
        !this.$store.state.trade.tvEnabled &&
        this.$store.state.trade.tvLoading
      ) {
        return
      }
      this.$store.state.trade.editTradeId = null
      this.$store.state.trade.editTrade = null

      if (this.$route.name === 'terminal') {
        if (
          this.$store.state.sys.selSymbols[this.currentExchangeId] === symbol
        ) {
          return
        }
        terminal.selectSymbol(symbol)
      } else if (this.$route.name === 'bots') {
        Bots.SelectBotSymbol(symbol)
      } else if (this.$route.name === 'grids') {
        Grids.SelectGridsSymbol(symbol)
      }
    },
    changeUSDBTCValue (exId) {
      if (this.currentExchangeId !== exId) {
        return
      }
      switch (this.$store.state.sys.usdbtc) {
        case 'USD':
          this.$store.state.sys.usdbtc = 'BTC'
          break
        case 'BTC':
          this.$store.state.sys.usdbtc = 'USD'
          break
      }
    },
    getExUrl (ex) {
      const isDark = this.$store.state.sys.theme === 'dark'
      switch (ex) {
        case 'BIN':
        case 'BIM':
          return require('@/assets/exlogo/bin.svg')
        case 'BIF':
          return require('@/assets/exlogo/bif.svg')
        case 'BIT':
          return require('@/assets/exlogo/bit.png')
        case 'EXM':
          return isDark ? require('@/assets/exlogo/exm_dark_theme.svg') : require('@/assets/exlogo/exm.svg')
        case 'HUO':
          return isDark ? require('@/assets/exlogo/htx_dark_theme.svg') : require('@/assets/exlogo/htx.svg')
        case 'FTX':
          return require('@/assets/exlogo/ftx.svg')
        case 'OKX':
          return isDark ? require('@/assets/exlogo/okx_dark_theme.svg') : require('@/assets/exlogo/okx.svg')
        case 'BYF':
          return isDark ? require('@/assets/exlogo/byf_dark_theme.svg') : require('@/assets/exlogo/byf.svg')
        case 'BYB':
          return isDark ? require('@/assets/exlogo/byb_dark_theme.svg') : require('@/assets/exlogo/byb.svg')
        case 'GET':
          return isDark ? require('@/assets/exlogo/get_dark_theme.svg') : require('@/assets/exlogo/get.svg')
        case 'GEF':
          return isDark ? require('@/assets/exlogo/gef_dark_theme.svg') : require('@/assets/exlogo/gef.svg')
      }
      // return require('@/assets/exlogo/' + ex + '.png')
    },
    showEditModal (index) {
      this.$store.state.show.exchangeModalIndex = 1
      this.$store.state.show.exchangeModal = true
    },
    showAddModal () {
      this.$store.state.show.exchangeModalIndex = -1
      this.$store.state.show.exchangeModal = true
    },
    exchValue (eid) {
      if (this.$store.state.sys.exchValue[eid]) {
        switch (this.$store.state.sys.usdbtc) {
          case 'USD':
            return '$' + this.$store.state.sys.exchValue[eid].usd
          case 'BTC':
            return this.$store.state.sys.exchValue[eid].btc + ' BTC'
        }
      }
    },
    async demoChanged (demoEnabledState) {
      if (demoEnabledState) {
        this.$store.state.assets.allexchs = false
      }
      this.$store.commit('setDemoState', demoEnabledState)
      await this.$store.dispatch('updateExchanges')
      if (this.$store.state.sys.exchanges.length === 0) {
        this.$store.state.show.exchangeModalIndex = -1
        this.$store.state.show.exchangeModal = true
        return
      }
      this.toggleDemoBackground()
    },
    toggleDemoBackground () {
      const setDemoBackground = () => {
        document.getElementsByTagName('body')[0].style.cssText +=
          'background-color: var(--color-demo)!important'
      }

      const setDefaultBackground = () => {
        document.getElementsByTagName('body')[0].style.backgroundColor = ''
      }

      if (this.$route.meta.showDemoBackground) {
        this.demoEnabled ? setDemoBackground() : setDefaultBackground()
      } else {
        setDefaultBackground()
      }
    },
    selectExch (index) {
      // console.log(index)
      if (
        !this.$store.state.trade.tvEnabled &&
        this.$store.state.trade.tvLoading
      ) {
        // console.log('tv not loaded. ignore exch change')
        return
      }
      this.$store.state.trade.editTradeId = null
      this.$store.state.trade.editTrade = null
      this.currentExchange = this.exchanges[index]
      this.$store.state.assets.allexchs = false
      saveTradeExchange(this.currentExchange, this.$store.state.sys.demo)
    }
  }
}
</script>
